import { BaseModel } from "sjs-base-model";
import EstimatesModel from "./EstimatesModel";
import SimulationsResultModel from "./SimulationsResultModel";

export default class SearchModel extends BaseModel {
    public readonly simulationsResult: SimulationsResultModel[] = [];
    public readonly estimatesResult: EstimatesModel[] = [];

    constructor(data: Partial<SearchModel>) {
        super();

        this.update(data);
    }
}
